import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Login from './Login'
import Signup from './Signup'
import Dashboard from './Dashboard'
import SecretAdmin from './SecretAdmin'
import ShreeKanikaMilk from './ShreeKanikaMilk'
import DoctorKanika from './DoctorKanika'
import KanikaMilkCenter from './KanikaMilkCenter'
import ChangePassword from './ChangePassword'
import AdminPanel from './AdminPanel'

export default function App(){
  return (
    <div style={{padding:20,fontFamily:'Arial'}}>
      <Routes>
        {/* root shows the Login form per user request */}
        <Route path="/" element={<Login/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/dashboard" element={<Dashboard/>} />
        <Route path="/shree-kanika-milk" element={<ShreeKanikaMilk company="Shree Kanika Milk"/>} />
        <Route path="/doctor-kanika" element={<DoctorKanika/>} />
        <Route path="/kanika-milk-center" element={<KanikaMilkCenter/>} />
        <Route path="/change-password" element={<ChangePassword/>} />
        <Route path="/admin-panel" element={<AdminPanel/>} />
        <Route path="/signup" element={<Signup/>} />
        <Route path="/secret-admin" element={<SecretAdmin/>} />
      </Routes>
    </div>
  )
}
